var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixTableReservationsV1Reservation from '@wix/ambassador-table-reservations-v1-reservation/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Status;
(function (Status) {
    Status["UNKNOWN"] = "UNKNOWN";
    /** The reservation is held for 10 minutes, during which time the reservee should fill in their details. */
    Status["HELD"] = "HELD";
    /** The reservation has been reserved. */
    Status["RESERVED"] = "RESERVED";
    /** The reservation has been canceled. */
    Status["CANCELED"] = "CANCELED";
    /** The reservation has finished successfully. */
    Status["FINISHED"] = "FINISHED";
    /** The reservee didn't arrive. */
    Status["NO_SHOW"] = "NO_SHOW";
    /** The reservee occupied the table. */
    Status["SEATED"] = "SEATED";
    /** The reservee requested a reservation and is waiting for manual approval. */
    Status["REQUESTED"] = "REQUESTED";
    /** The owner declined a reservee's request. */
    Status["DECLINED"] = "DECLINED";
    /** The reservation is held for 10 minutes from the created time, during which time the reservee should pay. After payment is completed status will be changed automatically to RESERVED. */
    Status["PAYMENT_PENDING"] = "PAYMENT_PENDING";
})(Status || (Status = {}));
export var Source;
(function (Source) {
    Source["UNKNOWN"] = "UNKNOWN";
    /** The reservation is created by a User. */
    Source["OFFLINE"] = "OFFLINE";
    /** The reservation is created by UoU. */
    Source["ONLINE"] = "ONLINE";
    /** The reservation is created by a User. It can be created without reservee data. */
    Source["WALK_IN"] = "WALK_IN";
})(Source || (Source = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["UNKNOWN"] = "UNKNOWN";
    /** A reservation is free of charge. */
    PaymentStatus["FREE"] = "FREE";
    /** A payment is not received yet. */
    PaymentStatus["NOT_PAID"] = "NOT_PAID";
    /** A corresponding to reservation order was fully payed. */
    PaymentStatus["PAID"] = "PAID";
    /** A corresponding to reservation order was refunded, but refund amount is less than order total price. */
    PaymentStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    /** A corresponding to reservation order was fully refunded. The refund amount equals total price. */
    PaymentStatus["FULLY_REFUNDED"] = "FULLY_REFUNDED";
    /** A corresponding to reservation order was partially payed. */
    PaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
})(PaymentStatus || (PaymentStatus = {}));
export var TableCombinationConflictType;
(function (TableCombinationConflictType) {
    TableCombinationConflictType["UNKNOWN"] = "UNKNOWN";
    TableCombinationConflictType["RESERVED"] = "RESERVED";
    TableCombinationConflictType["TOO_BIG"] = "TOO_BIG";
    TableCombinationConflictType["TOO_SMALL"] = "TOO_SMALL";
    TableCombinationConflictType["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(TableCombinationConflictType || (TableCombinationConflictType = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["PARTY_PACING"] = "PARTY_PACING";
    Type["SEAT_PACING"] = "SEAT_PACING";
})(Type || (Type = {}));
export var Set;
(function (Set) {
    Set["PUBLIC"] = "PUBLIC";
    Set["FULL"] = "FULL";
})(Set || (Set = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortType;
(function (SortType) {
    SortType["COUNT"] = "COUNT";
    SortType["VALUE"] = "VALUE";
})(SortType || (SortType = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["DESC"] = "DESC";
    SortDirection["ASC"] = "ASC";
})(SortDirection || (SortDirection = {}));
export var MissingValues;
(function (MissingValues) {
    MissingValues["EXCLUDE"] = "EXCLUDE";
    MissingValues["INCLUDE"] = "INCLUDE";
})(MissingValues || (MissingValues = {}));
export var ScalarType;
(function (ScalarType) {
    ScalarType["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
    ScalarType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    ScalarType["MIN"] = "MIN";
    ScalarType["MAX"] = "MAX";
    ScalarType["SUM"] = "SUM";
    ScalarType["AVG"] = "AVG";
})(ScalarType || (ScalarType = {}));
export var NestedAggregationType;
(function (NestedAggregationType) {
    NestedAggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    NestedAggregationType["VALUE"] = "VALUE";
    NestedAggregationType["RANGE"] = "RANGE";
    NestedAggregationType["SCALAR"] = "SCALAR";
    NestedAggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
})(NestedAggregationType || (NestedAggregationType = {}));
export var Interval;
(function (Interval) {
    Interval["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
    Interval["YEAR"] = "YEAR";
    Interval["MONTH"] = "MONTH";
    Interval["WEEK"] = "WEEK";
    Interval["DAY"] = "DAY";
    Interval["HOUR"] = "HOUR";
    Interval["MINUTE"] = "MINUTE";
    Interval["SECOND"] = "SECOND";
})(Interval || (Interval = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    AggregationType["VALUE"] = "VALUE";
    AggregationType["RANGE"] = "RANGE";
    AggregationType["SCALAR"] = "SCALAR";
    AggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
    AggregationType["NESTED"] = "NESTED";
})(AggregationType || (AggregationType = {}));
export var Mode;
(function (Mode) {
    /** any */
    Mode["OR"] = "OR";
    /** all */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _cancelReservationRequest = {};
const _cancelReservationResponse = {};
const _createHeldReservationRequest = {};
const _createHeldReservationResponse = {};
const _createReservationRequest = {};
const _createReservationResponse = {};
const _deleteReservationRequest = {};
const _deleteReservationResponse = {};
const _getReservationRequest = {};
const _getReservationResponse = {};
const _listReservationsRequest = {};
const _listReservationsResponse = {};
const _queryReservationsRequest = {};
const _queryReservationsResponse = {};
const _reserveReservationRequest = {};
const _reserveReservationResponse = {};
const _searchReservationsRequest = {};
const _searchReservationsResponse = {};
const _updateReservationRequest = {};
const _updateReservationResponse = {};
/**
 * Creates a new reservation.
 *
 * `createReservation()` accepts and requires different fields depending on the `status` provided and your permissions.
 *
 * **Status and source**
 *
 * If a `status` is not provided, it will be set to:
 * * `RESERVED` if manual approval is not required for confirmation
 * * `REQUESTED` if manual approval is required for confirmation.
 *
 * A reservation created with any `source` other than `WALK_IN` requires the `reservation.reservee.phone` and `reservation.reservee.firstName` fields.
 * Attempting to create a reservation without these fields will result in an error.
 *
 * **Permissions**
 *
 * Including the fields `status`, `source`, `reservation.details.tableIds`, `reservation.details.endDate`, `ignoreReservationLocationConflicts`, or `ignoreTableCombinationConflicts` in the request requires additional permissions. See this API's Introduction article for more information.
 *
 * If `source` is not provided, its value is set depending on the permissions of the user making the call. See this API's Introduction article for more information.
 *
 *
 *  > **Note:** `createReservation()` requires all details of the reservation upfront. The process of creating a reservation can be broken up using `createHeldReservation`.  `createHeldReservation` creates a temporary reservation that expires automatically unless it is completed with the addition of more details using `reserveReservation()`.
 * @param reservation - Reservation details.
 * @public
 * @documentationMaturity preview
 * @requiredField reservation
 * @requiredField reservation.details
 * @requiredField reservation.details.partySize
 * @requiredField reservation.details.reservationLocationId
 * @requiredField reservation.details.startDate
 * @param options - Options for creating the reservation.
 * @returns Reservation.
 */
export function createReservation(reservation, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            reservation: '$[0]',
            force: '$[1].force',
            ignoreTableCombinationConflicts: '$[1].ignoreTableCombinationConflicts',
            ignoreReservationLocationConflicts: '$[1].ignoreReservationLocationConflicts',
        };
        const responseTransformation = '$.reservation';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createReservationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['reservation']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createReservationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['reservation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reservation, options]);
        const reqOpts = ambassadorWixTableReservationsV1Reservation.createReservation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reservation',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a reservation.
 *
 * Calling this method with `fieldsets` set to `FULL` requires additional permissions. See this API's Introduction article for more information.
 * @param reservationId - Reservation ID.
 * @public
 * @documentationMaturity preview
 * @requiredField reservationId
 * @returns Reservation.
 */
export function getReservation(reservationId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            reservationId: '$[0]',
            fieldSet: '$[1].fieldSet',
            fieldsets: '$[1].fieldsets',
        };
        const responseTransformation = '$.reservation';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getReservationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getReservationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['reservation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reservationId, options]);
        const reqOpts = ambassadorWixTableReservationsV1Reservation.getReservation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reservationId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a reservation.
 *
 * Including the fields `status`, `source`, `reservation.details.tableIds`, `reservation.details.endDate`, `ignoreReservationLocationConflicts`, and `ignoreTableCombinationConflicts` in the request requires additional permissions. See this API's Introduction article for more information.
 *
 * Each time the reservation is updated, revision increments by 1. The existing revision must be included when updating the reservation. This ensures you're working with the latest reservation information, and it prevents unintended overwrites.
 * @param _id - Reservation ID.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField reservation
 * @requiredField reservation.revision
 * @param options - Options for updating the reservation.
 * @param reservation - Reservation information to update.
 * @adminMethod
 * @returns Reservation.
 */
export function updateReservation(_id, reservation, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            reservation: { '*': '$[1]', id: '$[0]' },
            mask: '$[2].mask',
            force: '$[2].force',
            ignoreTableCombinationConflicts: '$[2].ignoreTableCombinationConflicts',
            ignoreReservationLocationConflicts: '$[2].ignoreReservationLocationConflicts',
        };
        const responseTransformation = '$.reservation';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateReservationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['reservation']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateReservationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['reservation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, reservation, options]);
        const reqOpts = ambassadorWixTableReservationsV1Reservation.updateReservation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'reservation',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a new temporary reservation and holds it for the customer for 10 minutes.
 *
 * Creates a new reservation with the `HELD` status. `HELD` reservations are intended to reserve seats and tables for a party in a selected time slot while they enter further reservation details, such as names and contact information. Reservations with the `HELD` status are only valid for 10 minutes. Trying to change a `HELD` reservation’s status after 10 minutes returns an error.
 *
 * You cannot call `updateReservation()` to change a reservation’s status from `HELD`. Trying to do so returns an error. Instead, you should use `reserveReservation()`.
 *
 * If you do not wish to have `HELD` reservations in your flow, you can create a reservation with all required details using `createReservation()`.
 *
 * @param reservationDetails - Held reservation information to update.
 * @public
 * @documentationMaturity preview
 * @requiredField reservationDetails
 * @requiredField reservationDetails.partySize
 * @requiredField reservationDetails.reservationLocationId
 * @requiredField reservationDetails.startDate
 */
export function createHeldReservation(reservationDetails) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { reservationDetails: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createHeldReservationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createHeldReservationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['reservation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reservationDetails]);
        const reqOpts = ambassadorWixTableReservationsV1Reservation.createHeldReservation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reservationDetails',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Reserves or requests a held reservation.
 *
 * Held reservations are temporary reservations with the `HELD` status created by `createHeldReservation()`.
 *
 * They are intended to reserve seats and tables for a party in a selected time slot while they enter further reservation details, such as names and contact information. Reservations with the `HELD` status are only valid for 10 minutes. Trying to call `Reserve Reservation` with a held reservation older than 10 minutes returns an error.
 *
 * `Reserve Reservation` changes a reservation's `HELD` status to:
 * * `RESERVED` if the reservation's reservation location does not require manual approval.
 * * `REQUESTED` if the reservation's reservation location requires manual approval.
 * @param reservationId - Reservation ID.
 * @param reservee - Reservee details.
 * @param revision - Revision number.
 *
 * Include the existing `revision` to prevent conflicting updates to reservations.
 * @public
 * @documentationMaturity preview
 * @requiredField reservationId
 * @requiredField reservee
 * @requiredField reservee.firstName
 * @requiredField reservee.phone
 * @requiredField revision
 */
export function reserveReservation(reservationId, reservee, revision) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            reservationId: '$[0]',
            reservee: '$[1]',
            revision: '$[2]',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _reserveReservationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _reserveReservationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['reservation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reservationId, reservee, revision]);
        const reqOpts = ambassadorWixTableReservationsV1Reservation.reserveReservation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reservationId',
                'reservee',
                'revision',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Cancels a reservation.
 *
 * Sets the reservation status to `CANCELED`.
 * @param reservationId - Reservation ID.
 * @param revision - Revision number.
 *
 * Include the existing `revision` to prevent conflicting updates to reservations.
 * @public
 * @documentationMaturity preview
 * @requiredField reservationId
 * @requiredField revision
 * @param options - Options for canceling the reservation.
 */
export function cancelReservation(reservationId, revision, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            reservationId: '$[0]',
            revision: '$[1]',
            phone: '$[2].phone',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _cancelReservationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _cancelReservationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['reservation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reservationId, revision, options]);
        const reqOpts = ambassadorWixTableReservationsV1Reservation.cancelReservation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reservationId',
                'revision',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a reservation. Only reservations with the `HELD` status can be deleted.
 * @param reservationId - Reservation ID.
 * @internal
 * @documentationMaturity preview
 * @requiredField reservationId
 * @requiredField revision
 */
export function deleteReservation(reservationId, revision) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { reservationId: '$[0]', revision: '$[1]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteReservationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteReservationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reservationId, revision]);
        const reqOpts = ambassadorWixTableReservationsV1Reservation.deleteReservation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reservationId',
                'revision',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of up to 100 reservations.
 * @public
 * @documentationMaturity preview
 * @param options - Options for listing the reservations.
 * @adminMethod
 */
export function listReservations(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            paging: '$[0].paging',
            sort: '$[0].sort',
            startDateFrom: '$[0].startDateFrom',
            startDateTo: '$[0].startDateTo',
            status: '$[0].status',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listReservationsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listReservationsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#reservations']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixTableReservationsV1Reservation.listReservations(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a query to retrieve a list of reservations.
 *
 * The `queryReservations()` function builds a query to retrieve a list of reservations and returns a [`ReservationsQueryBuilder`](#ReservationsQueryBuilder) object.
 *
 * The returned object contains the query definition, which is used to run the query using the [find()](#ReservationsQueryBuilder/find) function.
 *
 * You can refine the query by chaining `ReservationsQueryBuilder` functions onto the query. `ReservationsQueryBuilder` functions enable you to filter, sort, and control the results that `queryReservations()` returns.
 *
 * `queryReservations()` runs with the following `ReservationsQueryBuilder` defaults, which you can override:
 *
 * * [`skip(0)`](#ReservationsQueryBuilder/skip)
 * * [`limit(50)`](#ReservationsQueryBuilder/limit)
 * * [`descending('_createdDate')`](#ReservationsQueryBuilder/descending)
 *
 * The following `ReservationsQueryBuilder` functions are supported for `queryReservations()`. For a full description of the reservation object, see the object returned for the [`items`](#ReservationsQueryResult/items) property in [`ReservationsQueryResult`](#ReservationsQueryResult).
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function queryReservations() {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.reservations',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[0];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryReservationsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryReservationsResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#reservations']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixTableReservationsV1Reservation.queryReservations(payload);
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/** @param search - Search query.
 * @public
 * @documentationMaturity preview
 * @requiredField search
 * @adminMethod
 */
export function searchReservations(search) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { search: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _searchReservationsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _searchReservationsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#reservations']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([search]);
        const reqOpts = ambassadorWixTableReservationsV1Reservation.searchReservations(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'search',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=table-reservations-v1-reservation.universal.js.map